export const selectLoader = state => state.loader;
